// CopyButton — one-click copy with "Copied!" feedback. Used for temp passwords,
// edge tokens, IDs — anywhere we previously expected the user to manually select.

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Copy, Check } from 'lucide-react';

export function CopyButton({ value, label, className }: { value: string; label?: string; className?: string }) {
  const { t } = useTranslation('components');
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch { /* clipboard blocked — no-op */ }
  };
  return (
    <button
      type="button"
      onClick={copy}
      className={`inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs ring-1 ring-white/10 hover:bg-white/5 ${copied ? 'text-ok' : 'text-muted'} ${className ?? ''}`}
      title={t('copyButton.tooltip')}
    >
      {copied ? <Check size={13} /> : <Copy size={13} />}
      {copied ? t('copyButton.copied') : (label ?? t('copyButton.copy'))}
    </button>
  );
}
